/* mo-nav.js: simplified header navigation (lane nav, 2026-11-03). Desktop panels (hover intent, click, keyboard),
   phone drawer accordions, Escape, focus trap, scroll lock release, open-now lines, and the chat quiz entry. */
(function () {
  var d = document, html = d.documentElement;

  /* Hours come from the live store data island that snippets/mo-your-store.liquid prints on every page. */
  var SH = null;
  function data() {
    if (SH) return SH;
    try { var el = d.querySelector('[data-mo-showrooms]'); if (el) SH = JSON.parse(el.textContent); } catch (e) { SH = null; }
    return SH;
  }
  function paint(root) {
    if (!root) return;
    var D = data();
    if (D && D.hoursText) [].forEach.call(root.querySelectorAll('[data-mo-hours-text]'), function (el) { el.textContent = 'Open ' + D.hoursText + '.'; });
    var M = window.MOLP; if (!M || !M.status || !D || !D.hours) return;
    [].forEach.call(root.querySelectorAll('[data-mo-status]'), function (el) {
      try {
        var s = M.status(D.hours); if (!s) return;
        el.textContent = s.text;
        el.classList.remove('is-open', 'is-soon', 'is-closed'); el.classList.add(s.cls);
      } catch (e) { /* keep the server text */ }
    });
  }

  /* The homepage guidance button's quiz start: open the chat bubble, then tap the hero chip, which sends
     "Help me find my match ..." (the phrase the server reads as a quiz start). Fallback: type it and send. */
  function startQuiz(e, after) {
    var b = d.querySelector('.shop-ai-chat-bubble');
    if (!(b && b.offsetParent !== null)) return; /* no chat: follow the link */
    e.preventDefault(); if (after) after();
    b.click();
    setTimeout(function () {
      var q = d.querySelector('.shop-ai-chip-hero');
      if (q) { q.click(); return; }
      var i = d.querySelector('.shop-ai-chat-input input'), s = d.querySelector('.shop-ai-chat-send');
      if (i && s) { i.value = 'Help me find my match'; i.dispatchEvent(new Event('input', { bubbles: true })); s.click(); }
    }, 80);
  }

  /* ---------- desktop ---------- */
  var nav = d.querySelector('[data-mo-nav]');
  if (nav) {
    var items = [].slice.call(nav.querySelectorAll('[data-mo-nav-item]')), cur = null, tO, tC;
    var set = function (li, on, focus) {
      var b = li.querySelector('.mo-nav__top'), p = li.querySelector('.mo-nav__panel');
      b.setAttribute('aria-expanded', on ? 'true' : 'false'); p.hidden = !on;
      if (on) { p.classList.add('is-in'); cur = li; paint(p); } else { p.classList.remove('is-in'); li._hov = 0; if (cur === li) cur = null; if (focus) b.focus(); }
      html.classList.toggle('mo-nav-panel-open', !!cur);
    };
    var closeAll = function (keep) { items.forEach(function (li) { if (li !== keep && li.querySelector('.mo-nav__top').getAttribute('aria-expanded') === 'true') set(li, false); }); };
    items.forEach(function (li) {
      var b = li.querySelector('.mo-nav__top');
      b.addEventListener('click', function () {
        var on = b.getAttribute('aria-expanded') === 'true';
        if (on && li._hov && Date.now() - li._hov < 900) { li._hov = 0; return; } /* opened by hover a moment ago: keep it */
        closeAll(li); set(li, !on);
      });
      li.addEventListener('pointerenter', function (e) {
        if (e.pointerType !== 'mouse') return;
        clearTimeout(tC); clearTimeout(tO);
        tO = setTimeout(function () { if (cur !== li) { closeAll(li); set(li, true); li._hov = Date.now(); } }, cur ? 40 : 140);
      });
      li.addEventListener('pointerleave', function (e) {
        if (e.pointerType !== 'mouse') return;
        clearTimeout(tO); tC = setTimeout(function () { set(li, false); }, 260);
      });
      li.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && b.getAttribute('aria-expanded') === 'true') { e.preventDefault(); set(li, false, true); }
        else if (e.key === 'ArrowDown' && e.target === b) {
          e.preventDefault(); if (b.getAttribute('aria-expanded') !== 'true') { closeAll(li); set(li, true); }
          var f = li.querySelector('.mo-nav__panel a'); if (f) f.focus();
        }
      });
      li.addEventListener('focusout', function (e) { if (e.relatedTarget && !li.contains(e.relatedTarget)) set(li, false); });
    });
    d.addEventListener('click', function (e) { if (cur && !cur.contains(e.target)) set(cur, false); });
    nav.addEventListener('click', function (e) {
      var q = e.target.closest('[data-mo-nav-quiz]'); if (q) startQuiz(e, function () { if (cur) set(cur, false); });
    });
  }

  /* ---------- phone drawer ---------- */
  var wrap = d.querySelector('.mobile-toggle-wrapper'), dr = d.getElementById('mobile-menu');
  if (wrap && dr && dr.classList.contains('mo-nd')) {
    var sum = wrap.querySelector('summary');
    var isOpen = function () { return wrap.hasAttribute('open'); };
    var sync = function () {
      var o = isOpen();
      html.classList.toggle('mo-nav-open', o);
      if (sum) { sum.setAttribute('aria-label', o ? 'Close menu' : 'Open menu'); sum.setAttribute('aria-expanded', o ? 'true' : 'false'); }
      if (!o) d.body.classList.remove('overflow-hidden');
      else paint(dr);
    };
    var close = function () {
      wrap.classList.remove('active'); wrap.removeAttribute('open'); d.body.classList.remove('overflow-hidden'); sync();
      if (sum) sum.focus();
    };
    new MutationObserver(sync).observe(wrap, { attributes: true, attributeFilter: ['open'] });
    sync();
    dr.addEventListener('click', function (e) {
      var b = e.target.closest('[data-mo-nav-acc]');
      if (b) {
        var on = b.getAttribute('aria-expanded') !== 'true', s = d.getElementById(b.getAttribute('aria-controls'));
        b.setAttribute('aria-expanded', on ? 'true' : 'false'); if (s) { s.hidden = !on; if (on) paint(s); }
        return;
      }
      var q = e.target.closest('[data-mo-nav-quiz]'); if (q) startQuiz(e, close);
    });
    d.addEventListener('keydown', function (e) {
      if (!isOpen()) return;
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key !== 'Tab') return;
      var f = [sum].concat([].slice.call(dr.querySelectorAll('a[href], button, input:not([type=hidden]), select, [tabindex]:not([tabindex="-1"])'))
        .filter(function (el) { return el.offsetParent !== null && !el.disabled; }));
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && d.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && d.activeElement === last) { e.preventDefault(); first.focus(); }
      else if (!wrap.contains(d.activeElement)) { e.preventDefault(); first.focus(); }
    });
  }
})();
